import React, { useContext, useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Typeahead } from 'react-bootstrap-typeahead';
import {
    Button, Grid,
    CardActionArea, CardActions, CardContent, Checkbox, Container, createMuiTheme, CssBaseline, FormControl, FormControlLabel, FormLabel,
    List, ListItem, ListItemSecondaryAction, ListItemText, Radio, RadioGroup, Snackbar, Step, StepConnector, StepLabel, Stepper, Toolbar, Typography,
    Backdrop, CircularProgress, Dialog, DialogContent, DialogActions, AppBar
} from '@material-ui/core';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import AddIcon from '@material-ui/icons/Add';
import CheckIcon from '@material-ui/icons/Check';
import CancelIcon from '@material-ui/icons/Cancel';
import MuiAlert from '@material-ui/lab/Alert';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';
import { makeStyles, withStyles } from "@material-ui/core/styles";
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import 'date-fns';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { history } from '../../apiAuthorization/history';
import { HttpService } from "../../apiAuthorization/httpService";
import { OfflineService } from "../../offline/storageService/offlineService";
import { SaveRoundOfflineData } from "../../offline/dataService/roundOfflineData";
import { GlobalTheme } from '../../layouts/theme';
import { TransactionTime } from '../common/transactionTime';
import { Context } from "../contexts/siteContext";
import { Theme } from '../contexts/themeContext';
import { ConvertTimeToUTC, ConvertToCurrentTimeZone } from '../header/timeFormatter';
import Card from "../card/card.js";
import CardBody from "../card/cardBody.js";
import NotesDialog from './notesDialog';
import UnsatDialog from './unsatDialog';
import TeamCoachList from '../teamCoach/teamCoachAdd';
import SmallMenu from '../header/smallMenu';
import StatusIcon from '../common/statusIcon';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: '5px 0px',
            width: '100%'
        }
    },
    button: {
        width: '15%',
        float: 'right'
    },
    error: {
        fontSize: '12px',
        fontWeight: "bold",
        color: 'red',
        marginTop: '-5px'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    colorCode: {
        marginRight: '5px', color: 'inherit', paddingTop: '14px'
    },
    legend: {
        width: '16px', height: '16px', display: 'inline-block'
    }
}));

const useQontoStepIconStyles = makeStyles({
    root: {
        color: '#eaeaf0',
        display: 'flex',
        height: 22,
        alignItems: 'center'
    },
    active: {
        color: '#E45B1A'
    },
    circle: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: 'currentColor'
    },
    completed: {
        color: '#E45B1A',
        zIndex: 1,
        fontSize: 18
    },
});

const QontoConnector = withStyles({
    alternativeLabel: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)'
    },
    active: {
        '& $line': {
            borderColor: '#E45B1A'
        }
    },
    completed: {
        '& $line': {
            borderColor: '#E45B1A'
        }
    },
    line: {
        borderColor: '#eaeaf0',
        borderTopWidth: 3,
        borderRadius: 1
    }
})(StepConnector);

function QontoStepIcon(props) {
    const classes = useQontoStepIconStyles();
    const { active, completed } = props;

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
            })}
        >
            {completed ? <CheckIcon className={classes.completed} /> : <div className={classes.circle} />}
        </div>
    );
}

QontoStepIcon.propTypes = {
    /**
     * Whether this step is active.
     */
    active: PropTypes.bool,
    /**
     * Mark the step as completed. Is passed to child components.
     */
    completed: PropTypes.bool,
};

function getSteps() {
    return ['Pick Round List', 'Enter Round', 'Complete Round'];
}

export default function RoundsList(props) {
    const classes = useStyles();
    const offlineService = new OfflineService();
    const { defaultSite } = useContext(Context);
    const { theme } = useContext(Theme);
    const [activeStep, setActiveStep] = React.useState(0);
    const [roundCheckValue, setRoundCheckValue] = useState(1);
    const [radio, setRadio] = useState(false);
    const [roundListName, setRoundListName] = useState('');
    const [notes, setNotes] = useState('');
    const [unsatisfactoryCheckBox, setUnsatisfactoryCheckBox] = useState(false);
    const [completedCheckBox, setCompletedCheckBox] = useState(false);
    const [managerConfirmedCheckBox, setManagerConfirmedCheckBox] = useState(false);
    const [locationsForRoundAll, setLocationsForRoundAll] = useState({
        id: 0, idBra: 0, name: '', aid: 0, round1Color: '', round2Color: '', round3Color: '', isSat1: '', isSat2: false, isSat3: false, CheckValue: ''
    });
    const [locationsForRound, setLocationsForRound] = useState({
        id: 0, idBra: 0, name: '', aid: 0, round1Color: '', round2Color: '', round3Color: '', isSat1: '', isSat2: false, isSat3: false, CheckValue: ''
    });
    const [selectedLocationForRound, setSelectedLocationForRound] = useState([]);
    const [unsatRound, setUnsatRound] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedDate, setSelectedDate] = useState(ConvertToCurrentTimeZone(new Date(), "L", null, defaultSite));
    const [selected, setSelected] = useState(props.siteLocation ? props.siteLocation : []);
    const [locations, setLocations] = useState([]);
    const [openTeamCoach, setOpenTeamCoach] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [openSuccess, setOpenSuccess] = useState(false);
    const [backDrop, setBackDrop] = useState(false);
    const [openNotes, setOpenNotes] = useState(false);
    const steps = getSteps();
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);

    const handleStep = (step) => () => {
        if (step === 2 && activeStep === 1)
            setActiveStep(step);
    };

    const closeSuccessSnackbar = () => {
        setOpenSuccess(false);
        setSelected([]);
    };

    const closeDialog = () => {
        TransactionTime.cancel();
        setOpenDialog(false);
        setOpenNotes(false);
    };

    const closeTeamCoach = (coachId) => {
        if (coachId !== undefined) {
            setSuccessMessage("TeamCoach Form ID: " + coachId + " has been completed successfully.");
            setOpenSuccess(true);
        }
        setOpenTeamCoach(false);
    };

    const getShortName = (name) => {
        if (name.indexOf("\\") === -1)
            return name;
        else
            return ".." + name.substring(name.indexOf("\\"));
    };

    const getRoundLists = () => {
        setBackDrop(true);
        HttpService.post('/Round/GetRoundLists', {
            siteCode: defaultSite.id.toString()
        })
            .then(async (result) => {
                if (result && result.offline) {
                    //get offline data
                    const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "RoundLists");
                    result = offlineResult.OfflineData;
                }
                else {
                    offlineService.removeOfflineBySite(defaultSite.id, "RoundLists");
                    offlineService.addOffline(defaultSite.id, "RoundLists", result);
                }
                var roundLists = result.filter(x => x.hasLocation > 0);
                setLocations(roundLists);
                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };

    const getRound = (location) => {
        setBackDrop(true);
        HttpService.post('/Round/GetAppRound', {
            RoundDate: selectedDate,
            GeoLocationId: location.id,
            GeoLocationAncestorId: location.aid,
            Round: parseInt(roundCheckValue),
            RoundListName: roundListName
        })
            .then(async (result) => {
                if (result && result.offline) {
                    //get offline data
                    const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "AppRounds");
                    let list = offlineResult.OfflineData.filter(x => (x.GeoLocationId === location.id) && (x.GeoLocationAncestorId === location.aid) && (x.RoundListName === roundListName) && (moment(x.RoundDate).format('L') === selectedDate) && (x.Round === parseInt(roundCheckValue)));
                    let item = {};
                    if (list.length > 0) {
                        item.id = list[0].AppRoundId;
                        item.roundDate = list[0].RoundDate;
                        item.round = list[0].Round;
                        item.location = list[0].GeoLocationId;
                        item.assignedTo = list[0].AssignedTo;
                        item.unsatisfactory = list[0].Unsatisfactory;
                        item.comment = list[0].Comment;
                        item.resolution = list[0].Resolution;
                        item.completed = list[0].Completed;
                        item.managerConfirmed = list[0].ManagerConfirmed;
                        item.createdUser = list[0].CreatedUser;
                        item.createdDateTime = list[0].CreatedDateTime;
                        item.modifiedUser = list[0].ModifiedUser;
                        item.modifiedDateTime = list[0].ModifiedDateTime;
                        item.taskNumber = list[0].TaskNumber;
                        item.requestDate = list[0].RequestedDatetime;
                        item.roundListName = list[0].RoundListName;
                    }
                    else {
                        item.id = -1;
                    }
                    result = item;
                }

                setUnsatRound(result);
                setSelectedLocationForRound(location);
                setOpenDialog(true);
                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };

    const getGeoLocationBranchRounds = (roundListName) => {
        setBackDrop(true);
        HttpService.post('/Round/GetGeoLocationBranchRounds', {
            Date: selectedDate,
            Site: defaultSite.id,
            RoundState: 'All',
            RoundListName: roundListName,
            UnsatisfactoryCheckBox: unsatisfactoryCheckBox,
            CompletedCheckBox: completedCheckBox,
            ManagerConfirmedCheckBox: managerConfirmedCheckBox,
            Key: '',
            MaxId: -1
        })
            .then(async (result) => {
                if (result && result.offline) {
                    //get offline data
                    const roundsOfflineResult = await offlineService.getOfflinesBySite(defaultSite.id, "AppRounds");
                    const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "GeoLocationBranchRounds-" + roundListName);
                    let appRounds = roundsOfflineResult.OfflineData;
                    let locations = offlineResult.OfflineData;
                    let locationsForSite = [];

                    locations.forEach(loc => {
                        appRounds.forEach(item => {
                            if (item.GeoLocationId === loc.id && moment(item.RoundDate).format('L') === selectedDate && item.RoundListName === roundListName && item.Round === parseInt(roundCheckValue)) {
                                if (item.Round === 1) {
                                    if (item.ManagerConfirmed)
                                        loc.round1Color = "green";
                                    else if (item.Completed)
                                        loc.round1Color = "yellow";
                                    else if (item.Unsatisfactory)
                                        loc.round1Color = "red";
                                    loc.isSat1 = item.IsSAT;
                                }
                                if (item.Round === 2) {
                                    if (item.ManagerConfirmed)
                                        loc.round2Color = "green";
                                    else if (item.Completed)
                                        loc.round2Color = "yellow";
                                    else if (item.Unsatisfactory)
                                        loc.round2Color = "red";
                                    loc.isSat2 = item.IsSAT;
                                }
                                if (item.Round === 3) {
                                    if (item.ManagerConfirmed)
                                        loc.round3Color = "green";
                                    else if (item.Completed)
                                        loc.round3Color = "yellow";
                                    else if (item.Unsatisfactory)
                                        loc.round3Color = "red";
                                    loc.isSat3 = item.IsSAT;
                                }
                            }
                        });

                        locationsForSite.push(loc);
                    });
                    result = locationsForSite;
                }
                else {
                    offlineService.removeOfflineBySite(defaultSite.id, "GeoLocationBranchRounds-" + roundListName);
                    offlineService.addOffline(defaultSite.id, "GeoLocationBranchRounds-" + roundListName, result);
                }
                setLocationsForRoundAll(result);
                setLocationsForRound(result);
                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };

    const getNotes = (roundListName) => {
        setBackDrop(true);
        HttpService.post('/Round/GetNotesForRoundLocation', {
            RoundDate: selectedDate,
            GeoLocationAncestorId: defaultSite.id,
            Round: parseInt(roundCheckValue),
            RoundListName: roundListName,
        })
            .then(async (result) => {
                if (result && result.offline) {
                    const roundsOfflineResult = await offlineService.getOfflinesBySite(defaultSite.id, "AppRounds");
                    let appRounds = roundsOfflineResult.OfflineData;
                    let list = appRounds.filter(x => (x.GeoLocationAncestorId === defaultSite.id) && (x.RoundListName === roundListName) && (moment(x.RoundDate).format('L') === selectedDate) && (x.Round === parseInt(roundCheckValue)));
                    if (list.length > 0)
                        setNotes(list[0].Notes);
                    else
                        setNotes("");
                }
                else {
                    setNotes(result.data);
                }
                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };

    const dateChanged = date => {
        date = moment(date).format("MM/DD/YYYY");
        setSelectedDate(date);
    };

    const locationChanged = (e) => {
        setSelected(e);
        if (e.length > 0) {
            setRoundListName(e[0].name);
            getGeoLocationBranchRounds(e[0].name);
            setActiveStep(1);
            getNotes(e[0].name);
        }
    };

    const locationSelected = (e, location) => {
        if (e.target.value) {
            var index = locationsForRound.findIndex(x => x.id === location.id);
            e.target.value === "SAT" ? satSave(location, index) : getRound(location);
        }
    };

    const getRoundColor = (round) => {
        var roundNum = parseInt(roundCheckValue);
        if (roundNum === 1) {
            round.CheckValue = round.isSat1;
            return round.round1Color;
        }
        else if (roundNum === 2) {
            round.CheckValue = round.isSat2;
            return round.round2Color;
        }
        else if (roundNum === 3) {
            round.CheckValue = round.isSat3;
            return round.round3Color;
        }
    };

    const filterLocations = (e, checkbox) => {
        var filter;
        var roundNum = parseInt(roundCheckValue);
        var unsatisfactoryTemp = unsatisfactoryCheckBox;
        var completedTemp = completedCheckBox;
        var managerConfirmedTemp = managerConfirmedCheckBox;

        if (checkbox === "Unsatisfactory") {
            setUnsatisfactoryCheckBox(e.target.checked);
            unsatisfactoryTemp = e.target.checked;
        }
        else if (checkbox === "Completed") {
            setCompletedCheckBox(e.target.checked);
            completedTemp = e.target.checked;
        }
        else if (checkbox === "Confirmed") {
            setManagerConfirmedCheckBox(e.target.checked);
            managerConfirmedTemp = e.target.checked;
        }

        if (unsatisfactoryTemp || completedTemp || managerConfirmedTemp) {
            if (roundNum === 1)
                filter = locationsForRoundAll.filter(x => (unsatisfactoryTemp && x.round1Color === 'red') || (completedTemp && x.round1Color === 'yellow') || (managerConfirmedTemp && x.round1Color === 'green'));
            if (roundNum === 2)
                filter = locationsForRoundAll.filter(x => (unsatisfactoryTemp && x.round2Color === 'red') || (completedTemp && x.round2Color === 'yellow') || (managerConfirmedTemp && x.round2Color === 'green'));
            if (roundNum === 3)
                filter = locationsForRoundAll.filter(x => (unsatisfactoryTemp && x.round3Color === 'red') || (completedTemp && x.round3Color === 'yellow') || (managerConfirmedTemp && x.round3Color === 'green'));

            setLocationsForRound(filter);
        }
        else
            setLocationsForRound(locationsForRoundAll);
    };

    const roundCheckValueChanged = (e) => {
        setRoundCheckValue(e.target.value);
        setRadio(true);
    };

    const completeRound = (startRound) => {
        if (startRound) {
            setActiveStep(0);
            setSelected([]);
            setUnsatisfactoryCheckBox(false);
            setCompletedCheckBox(false);
            setManagerConfirmedCheckBox(false);
        }
        else
            history.push("/");
    };

    const radioDisabled = (location) => {
        var roundNum = parseInt(roundCheckValue);
        if (roundNum === 1)
            return location.round1Color !== "";
        else if (roundNum === 2)
            return location.round2Color !== "";
        else if (roundNum === 3)
            return location.round3Color !== "";
    };

    const notesSave = (notes) => {
        setBackDrop(true);
        let model = {};
        model.RoundDate = selectedDate;
        model.GeoLocationAncestorId = defaultSite.id;
        model.Round = parseInt(roundCheckValue);
        model.RoundListName = roundListName;
        model.Notes = notes;

        HttpService.post('/Round/SaveNotesForRoundLocation', model)
            .then(async result => {
                if (result && result.offline) {
                    await SaveRoundOfflineData(defaultSite.id, 0, "SaveNotesForRoundLocation", model, "/Round/SaveNotesForRoundLocation", false, false);
                }
                else {
                    await SaveRoundOfflineData(defaultSite.id, 0, "SaveNotesForRoundLocation", model, "/Round/SaveNotesForRoundLocation", true, false);
                }
                setNotes(notes);
                setOpenSuccess(true);
                setSuccessMessage("Notes are saved successfully.");
                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };

    const satSave = (location, index) => {
        setBackDrop(true);
        let model = {};
        model.RoundDate = selectedDate;
        model.GeoLocationId = location.id;
        model.GeoLocationAncestorId = location.aid;
        model.Round = parseInt(roundCheckValue);
        model.RoundListName = roundListName;
        model.IsSAT = "SAT";
        model.Notes = notes;

        HttpService.post('/Round/SaveAppRoundWithSAT', model)
            .then(async result => {
                if (result && result.offline) {
                    await SaveRoundOfflineData(defaultSite.id, 0, "SaveAppRoundWithSAT", model, "/Round/SaveAppRoundWithSAT", false, false);
                }
                else {
                    model.AppRoundId = result.id;
                    await SaveRoundOfflineData(defaultSite.id, 0, "SaveAppRoundWithSAT", model, "/Round/SaveAppRoundWithSAT", true, false);
                }

                let newArray = [...locationsForRound];
                var roundNum = parseInt(roundCheckValue);
                if (roundNum === 1) {
                    newArray[index].isSat1 = "SAT";
                    newArray[index].round1Color = "";
                }
                else if (roundNum === 2) {
                    newArray[index].isSat2 = "SAT";
                    newArray[index].round2Color = "";
                }
                else if (roundNum === 3) {
                    newArray[index].isSat3 = "SAT";
                    newArray[index].round3Color = "";
                }
                setSelectedLocationForRound(location);
                setLocationsForRound(newArray);
                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };

    const unsatSave = (roundInfo, showCoach) => {
        let model = {};

        model.RoundDate = selectedDate;
        model.GeoLocationId = selectedLocationForRound.id;
        model.GeoLocationAncestorId = selectedLocationForRound.aid;
        model.Round = parseInt(roundCheckValue);
        model.RoundListName = roundListName;
        model.AssignedTo = roundInfo.defaultManager[0].id;
        model.AssignedToName = roundInfo.defaultManager[0].firstName + " " + roundInfo.defaultManager[0].lastName;
        model.Unsatisfactory = roundInfo.unsatisfactory;
        model.Comment = roundInfo.comment[0].name === "Other" ? "Other - " + roundInfo.otherComment : roundInfo.otherComment;
        model.Resolution = roundInfo.selectedResolution === "Assign To" ? roundInfo.selectedResolution + ":" + roundInfo.assignedDate : roundInfo.selectedResolution;
        model.Completed = Boolean(roundInfo.completed);
        model.ManagerConfirmed = Boolean(roundInfo.confirmed);
        model.TaskNumber = null;
        model.RequestDate = selectedDate;
        model.IsDeleted = Boolean(false);
        model.IsSAT = "UNSAT";
        model.ModifiedDateTime = ConvertTimeToUTC(new Date());
        model.TransactionStartLocal = roundInfo.TransactionStartLocal;
        model.TransactionEndLocal = roundInfo.TransactionEndLocal;
        model.SessionDuration = roundInfo.SessionDuration;
        model.WarningCount = roundInfo.WarningCount;
        model.Notes = notes;

        setBackDrop(true);
        HttpService.post("/Round/SaveAppRoundWithUNSAT", model)
            .then(async result => {
                if (result && result.offline) {
                    await SaveRoundOfflineData(defaultSite.id, 0, "SaveAppRoundWithUNSAT", model, "/Round/SaveAppRoundWithUNSAT", false, false);
                }
                else {
                    model.AppRoundId = result.id;
                    await SaveRoundOfflineData(defaultSite.id, 0, "SaveAppRoundWithUNSAT", model, "/Round/SaveAppRoundWithUNSAT", true, false);
                }

                var index = locationsForRound.findIndex(x => x.id === selectedLocationForRound.id);
                let newArray = [...locationsForRound];
                newArray[index].CheckValue = "UNSAT";

                var round = parseInt(roundCheckValue);
                if (round === 1) {
                    newArray[index].isSat1 = "UNSAT";
                    if (model.ManagerConfirmed)
                        newArray[index].round1Color = "green";
                    else if (model.Completed)
                        newArray[index].round1Color = "yellow";
                    else if (model.Unsatisfactory)
                        newArray[index].round1Color = "red";
                }
                else if (round === 2) {
                    newArray[index].isSat2 = "UNSAT";
                    if (model.ManagerConfirmed)
                        newArray[index].round2Color = "green";
                    else if (model.Completed)
                        newArray[index].round2Color = "yellow";
                    else if (model.Unsatisfactory)
                        newArray[index].round2Color = "red";
                }
                else if (round === 3) {
                    newArray[index].isSat3 = "UNSAT";
                    if (model.ManagerConfirmed)
                        newArray[index].round3Color = "green";
                    else if (model.Completed)
                        newArray[index].round3Color = "yellow";
                    else if (model.Unsatisfactory)
                        newArray[index].round3Color = "red";
                }
                setLocationsForRound(newArray);
                setBackDrop(false);
                if (showCoach) {
                    setOpenTeamCoach(true);
                }
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };

    useEffect(() => {
        getRoundLists();
        // eslint-disable-next-line 
    }, [selectedDate]);

    return (
        <React.Fragment>
            <ThemeProvider theme={currentTheme}>
                <CssBaseline />
                <Backdrop className={classes.backdrop} id="visitBackdrop" open={backDrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Snackbar open={openSuccess} autoHideDuration={3000} onClose={closeSuccessSnackbar} style={{ height: "100%" }}>
                    <Alert onClose={closeSuccessSnackbar} severity="success">
                        {successMessage}
                    </Alert>
                </Snackbar>
                <Dialog zindex="100" fullScreen open={openTeamCoach} disableBackdropClick={true} disableEscapeKeyDown={true}>
                    <DialogContent dividers>
                        <TeamCoachList goToComeFrom={closeTeamCoach} comeFrom={"Round"} roundLocationPath={selectedLocationForRound.name} />
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained"
                            color="secondary"
                            size="small"
                            className={classes.button}
                            style={{ width: "100px", marginRight: "60px" }}
                            onClick={e => closeTeamCoach()}
                            startIcon={<CancelIcon />}
                        >
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
                <Container maxWidth="xl" height="100%" className={props.styles}>
                    <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                        <Toolbar>
                            <Link to="/"><KeyboardBackspaceIcon /></Link>
                            <Typography variant="h6" className={classes.title}>&nbsp;Round</Typography><StatusIcon />
                            <Grid container justify="flex-end">
                                <SmallMenu moduleName={"Round"} modified={false} />
                            </Grid>
                        </Toolbar>
                    </AppBar>
                    <Card color="primary" style={{ height: "100%", background: currentTheme.background }}>
                        <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                            <div className={classes.root} autoComplete="off" >
                                {activeStep === 1 && <div className="label-date">
                                    <span className="ui teal tag label">{selectedDate}</span>
                                </div>}
                                <Stepper alternativeLabel activeStep={activeStep} connector={<QontoConnector />} style={{ backgroundColor: 'transparent' }}>
                                    {steps.map((label, index) => (
                                        <Step key={label}>
                                            <StepLabel StepIconComponent={QontoStepIcon} onClick={handleStep(index)} style={{ cursor: index === 2 ? 'pointer' : '' }}>{label}</StepLabel>
                                        </Step>
                                    ))}
                                </Stepper>
                                <div>
                                    {activeStep !== 2 && <>
                                        <FormLabel component="legend" style={{ width: "100px", margin: '14px 0px 0px 16px', color: 'inherit', float: 'left' }}>Round</FormLabel>
                                        <FormControl component="fieldset" disabled={activeStep === 1}>
                                            <RadioGroup aria-label="round" name="RoundCheckValue" style={{ display: 'block' }} value={roundCheckValue} onChange={roundCheckValueChanged}>
                                                {!radio && <FormControlLabel value="1" control={<Radio style={{ color: currentTheme.secondary }} checked={roundCheckValue === 1} />} label="1st" />}
                                                {!radio && <FormControlLabel value="2" control={<Radio style={{ color: currentTheme.secondary }} checked={roundCheckValue === 2} />} label="2nd" />}
                                                {!radio && <FormControlLabel value="3" control={<Radio style={{ color: currentTheme.secondary }} checked={roundCheckValue === 3} />} label="3rd" />}
                                                {radio && <FormControlLabel value="1" control={<Radio style={{ color: currentTheme.secondary }} />} label="1st" />}
                                                {radio && <FormControlLabel value="2" control={<Radio style={{ color: currentTheme.secondary }} />} label="2nd" />}
                                                {radio && <FormControlLabel value="3" control={<Radio style={{ color: currentTheme.secondary }} />} label="3rd" />}
                                            </RadioGroup>
                                        </FormControl>
                                    </>
                                    }
                                    {activeStep === 1 &&
                                        <>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="small"
                                                className={classes.button}
                                                style={{ background: currentTheme.secondary, width: 'auto', float: 'right', marginTop: '10px' }}
                                                startIcon={<AddIcon />}
                                                type="submit"
                                                onClick={e => setOpenNotes(true)}
                                            >
                                                Notes
                                            </Button>
                                            <Checkbox style={{ color: currentTheme.secondary, margin: '-5px -10px 0px 0px' }}
                                                checked={unsatisfactoryCheckBox} onChange={e => filterLocations(e, "Unsatisfactory")}
                                            />
                                            <label className={classes.colorCode}><span className={classes.legend} style={{ backgroundColor: '#e8c5c5' }}>&nbsp;</span>&nbsp;Unsatisfactory</label>
                                            <Checkbox style={{ color: currentTheme.secondary, margin: '-5px -10px 0px 0px' }}
                                                checked={completedCheckBox} onChange={e => filterLocations(e, "Completed")}
                                            />
                                            <label className={classes.colorCode}><span className={classes.legend} style={{ backgroundColor: '#f8efc2' }}>&nbsp;</span>&nbsp;Completed</label>
                                            <Checkbox style={{ color: currentTheme.secondary, margin: '-5px -10px 0px 0px' }}
                                                checked={managerConfirmedCheckBox} onChange={e => filterLocations(e, "Confirmed")}
                                            />
                                            <label className={classes.colorCode}><span className={classes.legend} style={{ backgroundColor: '#c9e5be' }}>&nbsp;</span>&nbsp;Manager Confirmed</label>
                                        </>
                                    }
                                </div>
                                {activeStep === 2 &&
                                    <div>
                                        <Card className={classes.root}>
                                            <CardActionArea>
                                                <CardContent>
                                                    <Typography gutterBottom variant="h6" component="h2" style={{ color: currentTheme.text }}>
                                                        Round {roundListName} has been completed, Do you want to start another Round?
                                                    </Typography>
                                                </CardContent>
                                            </CardActionArea>
                                            <CardActions>
                                                <Button size="small"
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.button}
                                                    style={{ background: currentTheme.secondary, width: "80px" , marginRight: "10px" }}
                                                    startIcon={<CheckIcon />}
                                                    onClick={() => { completeRound(true) }}
                                                >
                                                    Yes
                                                </Button>
                                                <Button size="small"
                                                    variant="contained"
                                                    color="secondary"
                                                    className={classes.button}
                                                    style={{ width: "80px" }}
                                                    startIcon={<CancelIcon />}
                                                    onClick={() => { completeRound(false) }}
                                                >
                                                    No
                                                </Button>
                                            </CardActions>
                                        </Card>
                                    </div>
                                }
                                {activeStep === 1 && <>
                                    <div style={{ height: window.innerHeight - 350 + 'px', overflow: 'auto' }}>
                                        <List dense className={classes.root}>
                                            {locationsForRound.length > 0 && locationsForRound.map((location) => {
                                                return (
                                                    <ListItem key={location.id} className={getRoundColor(location)} style={{ backgroundColor: '#BBDEFB', color: '#0D47A1' }} button>
                                                        <ListItemText id={location.id} primary={getShortName(location.name)} />
                                                        <ListItemSecondaryAction>
                                                            <FormControl component="fieldset" >
                                                                <RadioGroup aria-label="round" name="isSat" style={{ display: 'block' }} value={location.CheckValue} onClick={(e) => {
                                                                    locationSelected(e, location)
                                                                }}>
                                                                    {<FormControlLabel style={{ color: '#0D47A1' }} value="SAT" label="SAT" control={<Radio size="small" style={{ color: '#0D47A1' }} checked={location.CheckValue === 'SAT'} disabled={radioDisabled(location)} />} />}
                                                                    {<FormControlLabel style={{ color: '#0D47A1' }} value="UNSAT" label="UNSAT" control={<Radio size="small" style={{ color: '#0D47A1' }} checked={location.CheckValue === 'UNSAT'} />} />}
                                                                </RadioGroup>
                                                            </FormControl>
                                                        </ListItemSecondaryAction>
                                                    </ListItem>
                                                );
                                            })}
                                        </List>
                                    </div>
                                </>
                                }
                                {activeStep === 0 &&
                                    <>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker
                                                disableToolbar
                                                autoOk
                                                variant="inline"
                                                inputVariant="outlined"
                                                id="RoundDate"
                                                label="Date"
                                                format="MM/dd/yyyy"
                                                size="small"
                                                disableFuture="true"
                                                value={selectedDate}
                                                onChange={date => dateChanged(date)}
                                                InputAdornmentProps={{ position: "start" }}
                                                PopoverProps={{
                                                    anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                                    transformOrigin: { horizontal: "left", vertical: "top" }
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                        <Typeahead
                                            id="RoundList"
                                            labelKey="name"
                                            onChange={(e) => locationChanged(e)}
                                            options={locations}
                                            placeholder="Pick Round List..."
                                            selected={selected}
                                            renderMenuItemChildren={(option, key) => (
                                                <>
                                                    <div className="dropdown-widget">
                                                        <div className="left">{option.name}</div>
                                                    </div>
                                                </>
                                            )}
                                        />
                                    </>
                                }
                            </div>
                            {openDialog === true && <UnsatDialog openDialog={openDialog} onCloseDialog={closeDialog} onSave={unsatSave}
                                currentTheme={currentTheme} RoundLocation={selectedLocationForRound} UnsatRound={unsatRound} parentCallback={closeDialog} />}
                            {openNotes === true && <NotesDialog openDialog={openNotes} onCloseDialog={closeDialog} onSave={notesSave}
                                currentTheme={currentTheme} RoundLocation={roundListName} Notes={notes} />}
                        </CardBody>
                    </Card>
                </Container>
            </ThemeProvider>
        </React.Fragment>
    )
}
